/*
 * Copyright (c) 2018. keni <$email>
 *
 * This file parallax.js is part of event_pass_client.dev.
 * Unauthorized copying of this file, via any medium is strictly prohibited.
 * Proprietary and confidential
 * parallax.js can not be copied and/or distributed
 * without the express permission of keni
 */

import {guid as createId} from '../../shared/guid';
/**
 * Created by keni on 20/06/2017.
 * Simple parallax effect.
 * @todo make workable for more than one item on the dom
 */

let elm = '.est-parallax',
	settings = {
		speed: 0.5,
		up: false
	},
	elms={},
	prefix = 'data-parallax-';



/**
 * Upon window scrolling the background will be scrolled based on params
 */
function scroll() {
	window.onscroll = function () {
		[].slice.call(elm).forEach(function (el, i) {
			let windowYOffset = window.pageYOffset,
				id = $(el).attr('id'),
				goUp = (elms[id].up === 'true' ? -1 : 1);

			el.style.backgroundPosition = "50% " + (windowYOffset * elms[id].speed) * goUp + "px";
		});
	};
}

/**
 * Initialise each element
 */
function initFromElement() {
	$.each(elm,function(){
		let _this = $(this),
			id = _this.attr('id');
		if(!id){
			id = createId();
			_this.attr('id',id);
			elms[id] = {};
		}
		$.each(settings,function(i){
			let attr = _this.attr(prefix + i);

			if (attr) {
				elms[id][i] = attr;
			}else{
				elms[id][i] = settings[i];
			}
		});
	});
}

/**
 * Set up the options
 * @param options
 */
export function parallax(options) {
	settings = $.extend(settings, options, {});
	if ($('.parallax')) {
		elm = document.querySelectorAll(elm);
		initFromElement();
		scroll();
	}

}

/**
 * Export the module
 * @type {{parallax: init}}
 */
// module.exports = {
// 	parallax: init
// };



// WEBPACK FOOTER //
// ./resources/assets/js/components/front/effects/parallax.js